<template>
  <v-form ref="form" v-model="valid">
    <v-layout column v-if="mostrarComenzarConfiguracion || borradoDeFuera" px-4>
      <span class="grey--text v-label">
        {{$t('configuracion.sinConfiguracion')}}
      </span>
      <v-layout justify-center pt-4>
        <v-btn 
          @click="comenzarConfiguracion()" 
          large color="primary"
        >
          {{$t('general.misc.comenzar')}}
        </v-btn>
      </v-layout>
    </v-layout>
    <v-slide-y-transition>
      <div v-if="!mostrarComenzarConfiguracion && !borradoDeFuera">
        <v-layout
          :column="$vuetify.breakpoint.smAndDown" :justify-start="$vuetify.breakpoint.smAndDown"
        >
          <v-flex xs5>
            <v-layout column justify-start>
              <v-layout column justify-start>
                <p class="px-1 grey--text">
                  {{$t('configuracion.notaConfiguracion')}}
                </p>
                <p class="px-1 grey--text">
                  {{$t('configuracion.tiempoMaxDescripcionTres').substring(1)}}
                </p>
              </v-layout>
              <v-layout column v-if="alquiler">
                <o-thin-title>
                  {{$t('configuracion.scoring')}}
                </o-thin-title>
                <p class="px-1 grey--text">
                  {{$t('configuracion.scoringTexto')}}
                </p>
                <v-layout mx-2 >
                  <v-checkbox
                    color="primary"
                    class="grey--text pl-2 mt-0" 
                    v-model="scoring" 
                    :label="$t('configuracion.scoringLabel')"
                  >
                  </v-checkbox>
                </v-layout>
              </v-layout>
            </v-layout>
            <v-layout column v-if="!alquiler">
                <o-thin-title>
                  {{$t('configuracion.kyc')}}
                </o-thin-title>
                <p class="px-1 grey--text">
                  {{$t('configuracion.kycTexto')}}
                </p>
                <v-layout>
                  <v-checkbox
                    color="primary"
                    class="grey--text pl-2 mt-0" 
                    v-model="firmarKYC" 
                    :label="$t('configuracion.kycLabel')"
                  >
                  </v-checkbox>
                </v-layout>
              </v-layout>
            <v-select
                    :label="$t('reservaSimplificada.modalidadFirma')"
                    :items="tiposFirma"
                    item-text="text"
                    item-value="value"
                    v-model="modalidadFirma"
                    :rules="[rules.required]">
                    </v-select>
          </v-flex>
          <v-flex xs7 :class="!$vuetify.breakpoint.smAndDown ? 'pl-4' : ''">
            <v-layout column justify-start>
              <o-thin-title>
                {{$t('configuracion.miConfiguracion')}}
              </o-thin-title>
              <p class="px-1 grey--text">
               {{$t('configuracion.miConfiguracionTextoSimplificado')}} 
              </p>
              <v-card class="px-2 py-1">
                <v-layout
                  row justify-start align-start
                >
                  <v-flex
                    :style="{
                      position: 'relative'
                    }"
                  >
                    <v-card class="pa-2 mx-3 ma-2 modulo-reserva-item">
                      <v-card class="pr-2">
                        <v-layout column>
                          <v-layout row justify-start align-center>
                            <o-tint-img
                              class="modulo-image hidden-xs-only"
                              :src="require('@/assets/images/reserva/' + moduloCondiciones.tipo + '.jpg')"
                            />
                            <v-text-field 
                              :style="$vuetify.breakpoint.smAndDown ? 'max-width: 350px' : ''"
                              :label="getTexto('modulos.condiciones' + (alquiler ? 'Alquiler' : ''))"
                              :value="getNombreModulo('condiciones')"                      
                              class="pl-2 my-1"
                              readonly
                            />
                          </v-layout>
                        </v-layout>
                      </v-card>
                    </v-card><v-card class="pa-2 mx-3 ma-2 modulo-reserva-item">
                      <v-card class="pr-2">
                        <v-layout column>
                          <v-layout row justify-start align-center>
                            <o-tint-img
                              class="modulo-image hidden-xs-only"
                              :src="require('@/assets/images/reserva/' + 'kyc' + '.jpg')"
                            />
                            <v-text-field 
                              :style="$vuetify.breakpoint.smAndDown ? 'max-width: 350px' : ''"
                              :label="getTexto('modulos.kyc' + (alquiler ? 'Alquiler' : ''))"
                              :value="getNombreModulo('kyc')"                      
                              class="pl-2 my-1"
                              readonly
                            />
                          </v-layout>
                        </v-layout>
                      </v-card>
                    </v-card>
                    <v-card class="pa-2 mx-3 ma-2 modulo-reserva-item">
                      <v-card class="pr-2">
                        <v-layout column>
                          <v-layout row justify-start align-center>
                            <o-tint-img
                              class="modulo-image hidden-xs-only"
                              :src="require('@/assets/images/reserva/' + moduloDocumentacion.tipo + '.jpg')"
                            />
                            <v-text-field 
                              :style="$vuetify.breakpoint.smAndDown ? 'max-width: 350px' : ''"
                              :label="getTexto('modulos.documentacion' + (alquiler ? 'Alquiler' : ''))"
                              :value="getNombreModulo('documentacion')"                      
                              class="pl-2 my-1"
                              readonly
                            />
                          </v-layout>
                        </v-layout>
                      </v-card>
                    </v-card>
                    <v-card class="pa-2 mx-3 ma-2 modulo-reserva-item">
                      <v-card class="pr-2">
                        <v-layout column>
                          <v-layout row justify-start align-center>
                            <o-tint-img
                              class="modulo-image hidden-xs-only"
                              :src="require('@/assets/images/reserva/' + 'contrato' + '.jpg')"
                            />
                            <v-text-field 
                              :style="$vuetify.breakpoint.smAndDown ? 'max-width: 350px' : ''"
                              :label="getTexto('modulos.contrato' + (alquiler ? 'Alquiler' : ''))"
                              :value="getNombreModulo('contrato')"                      
                              class="pl-2 my-1"
                              readonly
                            />
                          </v-layout>
                        </v-layout>
                      </v-card>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout justify-center pt-4>
          <v-btn 
            :disabled="!cambiado || guardando"
            :loading="guardando"
            @click="guardarModulos()"
            large color="primary"
          >
              {{$t('general.misc.guardarCambios')}}
          </v-btn>
        </v-layout>
      </div>
    </v-slide-y-transition>
  </v-form>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import rulesMixin from '@/mixins/rules.js'

export default {
  mixins: [rulesMixin],

  props: {
    alquiler: {
      default: false,
      type: Boolean
    },
    borradoDeFuera: {
      default :false,
      type: Boolean
    },
    codigoPromocion: {
      default: null,
      type: String
    }
  },
  data () {
    return {
      modalidadFirma: null,
      modalidadFirmaBase: null,
      tiposFirma: [
        {
          value: 1,
          text: this.$t('reservaSimplificada.modalidadFirmaSignaturit')
        },
        {
          value: 2,
          text: this.$t('reservaSimplificada.modalidadFirmaPDF')
        },
        {
          value: 3,
          text: this.$t('reservaSimplificada.modalidadFirmaWord')
        },
      ],
      scoring: false,
      scoringBase: false,
      valid: false,
      putBase: false,
      moduloAgarrado: {},
      indexModuloAgarrado: 0,
      auxModulosPre: 0,
      mostrarPopUpAddModulos: false,
      addModulosEnPreReserva: false,
      guardando: false,
      cambiadoData: false,
      mostrarComenzarConfiguracion: false,
      firmarKYC: false,
      moduloDocumentacion: {
        tipo: 'documentacion',
        nombre: this.$t('configuracion.moduloDoc'),
        creaReserva: false
      },
      moduloCondiciones: {
        tipo: 'condiciones',
        nombre: this.$t('configuracion.moduloCondiciones'),
        creaReserva: false
      }
    }
  },
  created () {
    this.inicializar()
  },
  computed: {
    ...mapGetters({
      modulosOrdenStore: 'modulosOrdenes/getByAlquiler',
      modulosStore: 'modulosOrdenes/modulos/getAllByModulosOrdenId'
    }),
    modulosOrden () {
      return this.modulosOrdenStore({alquiler: this.alquiler, simplificada: 1, codigoPromocion: this.codigoPromocion})
    },
    modulosBase () {
      return [
        {
          tipo: 'kyc',
          nombre: this.$t('configuracion.moduloKyc'),
          creaReserva: false
        },
      ]
    },
    moduloDocumentacionBase() {
      return {
        tipo: 'documentacion',
        nombre: this.$t('configuracion.moduloDoc'),
        creaReserva: false
      }
    },
    moduloCondicionesBase () {
      return {
        tipo: 'condiciones',
        nombre: this.$t('configuracion.moduloCondiciones'),
        creaReserva: false
      }
    },
    modulosComputed: {
      get () {
        return this.alquiler ? this.modulosBase : this.modulosBase.concat(this.moduloPbcBase)
      },
      set () {
      }
    },
    todoVacio () {
      return this.amountPreModulos === 0 && this.amountPostModulos === 0
    },
    amountPreModulosConAux () {
      const amount = this.amountPreModulos + this.auxModulosPre
      return amount >= 0 ? amount : 0
    },
    hayModulos () {
      return (this.modulosPreReserva.length > 0)
    },
    cambiado () {
      if (this.modulosOrden != null) {
        if (this.modulosOrden.generarContratoKyc !== this.firmarKYC) {
          // eslint-disable-next-line
          this.cambiadoData = true
        }
      }
      return this.cambiadoData || this.variablesBasicasCambiadas
    },
    variablesBasicasCambiadas () {
      return this.cambiadoData ||
        this.scoring !== this.scoringBase ||
        this.modalidadFirma !== this.modalidadFirmaBase
    },
  },
  methods: {
    ...mapActions({
      guardarModulosOrden: 'modulosOrdenes/crear',
      addAlert: 'alerts/add'
    }),
    getNombreModulo(tipo) {
      return this.getTexto('modulos.' + tipo + (this.alquiler ? 'Alquiler' : ''))
    },
    inicializar () {
      if (this.modulosOrden != null) {
        this.scoring = this.modulosOrden.scoring
        this.scoringBase = this.scoring
        this.modalidadFirma = this.modulosOrden.modalidadFirma
        this.modalidadFirmaBase = this.modalidadFirma
        this.firmarKYC = this.modulosOrden.generarContratoKyc
      } else {
        this.mostrarComenzarConfiguracion = true
      }
    },
    comenzarConfiguracion () {
      this.$emit('resetBorrado', this.alquiler)
      this.cambiadoData = true
      this.mostrarComenzarConfiguracion = false
    },
    alertPreRefresh (e) {
      if (this.cambiado) {
        let message = this.$t('general.misc.alertPreRefresh')
        e = e || window.event
        // For IE and Firefox prior to version 4
        if (e) {
          e.returnValue = message
        }
        // For Safari
        return message
      }
    },
    async guardarModulos () {
      this.$refs.form.validate()
      if (!this.valid) {
        this.addAlert({texto: this.$t('general.misc.revisaCamposRojo'), color: 'error'})
        return
      }
      try {
        this.guardando = true
        const objetoParaApi = {
          alquiler: this.alquiler ? 1 : 0,
          scoring: this.scoring ? 1 : 0,
          generarContratoKyc: this.firmarKYC,
          codigoPromocion: this.codigoPromocion,
          modalidadFirma: this.modalidadFirma,
          simplificada: true
        }
        await this.guardarModulosOrden(objetoParaApi)
        
        this.inicializar()
        this.guardando = false
        this.cambiadoData = false
        this.addAlert({texto: this.$t('general.misc.datosGuardadosExito'), color: 'success'})
      } catch (error) {
        this.guardando = false
        if (!error.code || error.code !== 1) {
          this.addAlert({texto: error.message, color: 'error'})
        }
      }
    }
  },
  watch: {
    cambiadoData (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.$emit('cambiado', newValue)
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
  @require '~vuetify/src/stylus/settings/_colors'

#base .none
  display: none

.modulo-reserva-item
  background-color: $grey["lighten-4"] !important;
  min-height: 85px
  .modulo-image
    height: 85px
    width: 100px
    max-width: 100px
  .modulo-text
    font-weight: bold
    font-size: larger

.modulo-base-item
  background-color: $grey["lighten-4"] !important;
  .modulo-image
    height: 40px
    width: 60px
    max-width: 60px
  .modulo-text
    font-size: small
    font-weight: bold

.draggable-empty
  border: 3px dashed
  border-radius: 5px
  border-color: var(--v-primary-base)
  
</style>


// WEBPACK FOOTER //
// src/components/configuracion/ConfiguracionReservaSimplificada.vue